/**
 * 前端權限常數與頁面映射。
 *
 * 角色 code 與後端 `backend/Modules/Schedule/Constants/ScheduleRoleConstants.php`
 * 逐字對應 —— 那些字串存在 admin.roles 裡，任一邊改字串都會讓既有帳號的權限失效。
 *
 * 判斷權限一律用 `useAuthStore().hasPermission()`（讀後端展開後的 permissions），
 * 不要自行實作「super admin 自動全過」那條規則。
 */

export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN'
export const ROLE_SCHEDULE_UPLOAD_WRITE = 'ROLE_SCHEDULE_UPLOAD_WRITE'
export const ROLE_SCHEDULE_LISTING_READ = 'ROLE_SCHEDULE_LISTING_READ'
export const ROLE_SCHEDULE_HISTORY_READ = 'ROLE_SCHEDULE_HISTORY_READ'
export const ROLE_SCHEDULE_HISTORY_WRITE = 'ROLE_SCHEDULE_HISTORY_WRITE'

/**
 * 頁面路徑 → 進入該頁所需的權限（OR：具備其中任一即可）。
 *
 * 沒列在這裡的路徑（含 `/`、`/login`、`/forgot-password`）不設權限需求。
 * `/` 刻意不設，作為無權限者被守衛導回時的安全落點 —— 若它也要權限就會導頁導不完。
 */
const PAGE_PERMISSIONS: Record<string, string[]> = {
  '/upload': [ROLE_SCHEDULE_UPLOAD_WRITE],
  // 兩種讀權限任一即可：/listings 與後端 GET /{id}（含 GET /latest）語意對稱 ——
  // 兩頁點進去看的是同一份排播表，HISTORY_READ 帳號從歷史列表點進去理應看得到。
  '/listings': [ROLE_SCHEDULE_LISTING_READ, ROLE_SCHEDULE_HISTORY_READ],
  '/history': [ROLE_SCHEDULE_HISTORY_READ],
  '/admin': [ROLE_SUPER_ADMIN],
}

/**
 * 查某個路徑所需的權限。無需求時回空陣列。
 *
 * 子路徑（`/admin/create`、`/admin/<id>`）沿用父路徑的權限。比對時要求
 * 「完全相等」或「後面接 `/`」，不能用裸 startsWith —— 否則 `/uploader`
 * 會被當成 `/upload` 的子路徑而誤中。
 */
export function requiredPermissions(path: string): string[] {
  for (const [prefix, perms] of Object.entries(PAGE_PERMISSIONS)) {
    if (path === prefix || path.startsWith(`${prefix}/`)) return perms
  }
  return []
}
